export const MAX_BATCH_SIZE = 100;
//# sourceMappingURL=batch-constants.js.map